import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Input, InputProps } from 'antd';
import React from 'react';

type InputFieldProps = {
  error?: string;
} & InputProps;

const Password = (props: InputFieldProps) => {
  return (
    <>
      <Input.Password
        {...props}
        className="c-input"
        iconRender={(visible) =>
          visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
        }
        rootClassName="c-input__password"
      />
      {props.error && <span className="c-input__error">{props.error}</span>}
    </>
  );
};

export default Password;
